module.exports = __webpack_public_path__ + "assets/images/cockpit/hover/btn_summary-hover_ru.png";